<template>
  <div>
    <v-row>
      <v-col cols="12">
        <router-link :to="linkBack2" style="text-decoration: none" title="Back">
          <v-btn
            color="warning"
            fab
            small
            dark
            style="float: left; margin-left: 5px"
          >
            <v-icon class="fa fa-arrow-left"></v-icon>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="6" class="border">
          <b>Image Preview</b>
          <template v-if="dialog == false && dialogUpload == false">
            <v-carousel>
              <v-carousel-item
                v-for="i in dataProduct.preview_imgs"
                :key="i.img_id"
                reverse-transition="fade-transition"
                transition="fade-transition"
              >
                <img :src="i.img_url" :alt="i.image_url" style="height: 80%" />
              </v-carousel-item>
            </v-carousel>
          </template>
        </v-col>

        <v-col cols="6" class="border">
          <b>Upload Design</b>
          <v-row>
            <v-col cols="9" v-if="listFilter.length > 0">
              <v-row>
                <v-col cols="3" v-for="i in listFilter" :key="i.option">
                  <select
                    class="form-control"
                    v-model="i.selected"
                    @change="filterData"
                  >
                    <option value="">{{ i.option }}</option>
                    <option v-for="x of i.value" :key="x" :value="x">
                      {{ x }}
                    </option>
                  </select>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-btn
                color="orange"
                dark
                @click="dialogUpload = !dialogUpload"
                v-if="roles.update_crawled_product_design"
                >Upload</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="!dialogUpload">
            <v-col cols="12">
              <table width="100%" class="table table-striped">
                <thead class="thead-light">
                  <tr>
                    <th v-for="i in headers" :key="i">
                      {{ i }}
                    </th>
                    <th># Designs</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="i in listVariants">
                    <tr :key="i.variant_id" v-if="i.selected">
                      <td v-for="j in i.options" :key="j.name">
                        <input
                          type="text"
                          class="form-control"
                          v-model="j.value"
                          disabled
                        />
                      </td>
                      <td>{{ i.design_imgs.length }}</td>
                      <td>
                        <v-btn
                          color="primary"
                          small
                          @click="
                            dialog = !dialog;
                            assignData(i.design_imgs, i);
                          "
                        >
                          <v-icon>mdi-information</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <BaseDialog :active.sync="dialogUpload" dialog_name="Upload Design">
          <addDesign
            :designer_id="userId"
            :variants="listVariantsID"
            :product_id="this.$route.params.id"
            :product_code="this.dataProduct.product_code"
          />
        </BaseDialog>
        <BaseDialog :active.sync="dialog" dialog_name="Design List">
          <designList
            :listDesign="arrDesign"
            :variant_item="variant_item"
            :listVendors="listVendors"
            :listVariantsReceive="listVariantsSend"
            type="design"
          />
        </BaseDialog>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";
import BaseDialog from "../Common/c-base-dialog";
import addDesign from "./c-add-design-to-variants";
import designList from "./c-design-list";
//import Multiselect from 'vue-multiselect'

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  components: {
    //design,
    addDesign,
    BaseDialog,
    designList,
  },

  props: {
    params: String,
  },

  created() {
    this.$root.$refs.design = this;
  },

  data: () => ({
    dialog: false,
    dialogUpload: false,
    dataProduct: [],
    AuthStr: "",
    listProductType: [],
    listVariants: [],
    headers: [],
    product_type_id: "",
    listFilter: [],
    listVariantsID: [],
    userId: "",
    arrDesign: [],
    variant_item: [],
    listVendors: [],
    listVariantsSend: [],
    params2: "",
    linkBack2: "",
    roles: [],
  }),

  // watch:{
  //     dialogUpload:function (){
  //         if(this.dialogUpload == false)
  //         this.loadData()
  //     }
  // },

  methods: {
    async offDialog() {
      this.dialogUpload = false;
      await this.loadData();
      try {
        this.$root.$refs.seller.updateDesignNumber(this.listVariants);
      } catch (err) {
        return;
      }
    },

    // updateDesignNumber(){
    //     console.log("data updateDesignNumber")
    //     this.loadData();
    // },

    offDesignList() {
      this.dialog = false;
    },

    check() {
      console.log(this.listVariants);
    },

    assignData(design, variant) {
      this.arrDesign = [];
      this.variant_item = [];
      if (design) {
        design.forEach((e) => {
          this.arrDesign.push(e);
        });
      }
      this.variant_item = variant;
      for (const i of this.listVariants) {
        this.listVariantsSend.push(i.variant_id);
      }
    },

    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "crawl-product-detail-designer-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "products/" + this.$route.params.id, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            this.listVariants = [];
            this.headers = [];
            this.dataProduct = response.data.data.product;
            this.listProductType = response.data.data.productTypes;
            this.listTags = response.data.data.tags;
            this.listVendors = response.data.data.vendors;

            if (this.dataProduct.product_type_id != "") {
              for (const y of this.listProductType) {
                if (y._id == this.dataProduct.product_type_id) {
                  this.product_type_item = y.product_type;
                }
              }
            }

            if (this.dataProduct.variants.length > 0) {
              for (const j of this.listProductType) {
                if (j._id == this.dataProduct.product_type_id) {
                  for (const t of j.option_names) this.headers.push(t);
                }
              }
            }

            if (this.dataProduct.variants.length > 0) {
              for (const i of this.dataProduct.variants) {
                for (const n of this.listProductType) {
                  if (n._id == this.dataProduct.product_type_id) {
                    for (const m of n.variants) {
                      if (m.variant_id == i.variant_id) {
                        this.listVariants.push(m);
                      }
                    }
                  }
                }
              }

              for (const g of this.listVariants) {
                for (const s of this.dataProduct.variants) {
                  if (g.variant_id == s.variant_id) {
                    g["selected"] = true;
                    if (s.price) {
                      g.price = s.price;
                    }

                    if (s.gram) {
                      g.gram = s.gram;
                    }

                    if (s.design_imgs) {
                      g["design_imgs"] = s.design_imgs;
                    }
                  }
                }
              }
            }

            if (this.dataProduct.variants.length > 0) {
              this.loadFilter();
            }
          })
          .catch((error) => {
            console.log("error ", error);
          });

        this.listVariantsID = [];
        for (const u of this.listVariants) {
          if (u.selected == true) {
            this.listVariantsID.push(u);
          }
        }
      } else {
        console.log(
          "currentSession crawl-product-detail-designer-loadData: ",
          currentSession
        );
      }
    },

    //filter
    loadFilter() {
      this.listFilter.length = 0;
      var temp = [];
      //console.log(this.listProductType)
      for (let i = 0; i < this.listProductType.length; i++) {
        if (this.listProductType[i]._id == this.dataProduct.product_type_id) {
          for (const u of this.listProductType[i].option_names) {
            var item = {
              option: u,
              value: [],
              selected: "",
            };
            this.listFilter.push(item);
          }

          for (const f of this.listProductType[i].variants) {
            temp.push(f);
          }
        }
      }

      var check = new Set();
      for (const g of this.listFilter) {
        for (const h of temp) {
          for (const k of h.options) {
            if (g.option == k.name) {
              check.add(k.value);
            }
          }
        }
        g.value = Array.from(check);
        check = new Set();
      }
    },

    filterData() {
      for (const a of this.listVariants) {
        a.selected = true;
      }

      for (const i of this.listFilter) {
        if (i.selected != "") {
          for (const j of this.listVariants) {
            if (j.selected == true) {
              for (const k of j.options) {
                if (k.value == i.selected) {
                  j.selected = true;
                  break;
                } else {
                  j.selected = false;
                }
              }
            }
          }
        }
      }

      this.listVariantsID = [];
      for (const u of this.listVariants) {
        if (u.selected == true) {
          this.listVariantsID.push(u);
        }
      }
    },
  },
  async mounted() {
    this.roles = await this.$cookies.get("crawled_product");
    this.params2 = window.location.search;
    if(this.params2.indexOf("all-products") < 0){
      this.linkBack2 = "/products" + this.params2;
    }else{      
      this.linkBack2 = "/all-products" + this.params2;
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("product-detail-designer currentSession: ", currentSession);
      } catch (error) {
        console.log("product-detail-designer error: ", error);
      }

      if (currentSession != undefined) {
        this.userId = currentSession.accessToken.payload.username;
        //currentSession.accessToken.jwtToken;
      }
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>